import { render, staticRenderFns } from "./StaticPagePreviewLink.vue?vue&type=template&id=b0d5e1d0&scoped=true"
import script from "./StaticPagePreviewLink.vue?vue&type=script&lang=js"
export * from "./StaticPagePreviewLink.vue?vue&type=script&lang=js"
import style0 from "./StaticPagePreviewLink.vue?vue&type=style&index=0&id=b0d5e1d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d5e1d0",
  null
  
)

export default component.exports